/*
 * @Author: gaobin
 * @Date: 2025-01-14 16:37:35
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-17 11:44:02
 * @Description: user
 */
import { setLanguage } from '@/locale';
import { CUR_LANGUAGE, CUR_TOKEN, CUR_USERINFO } from '../mutation-types';

const user = {
  state: {
    // 语言
    lang: uni.getStorageSync(CUR_LANGUAGE) || 'ar',
    token: uni.getStorageSync(CUR_TOKEN) || '',
    // 用户信息
    userInfo: uni.getStorageSync(CUR_USERINFO) || {},
  },

  mutations: {
    SET_LANGUAGE: async (state, lang) => {
      state.lang = lang;
      uni.setStorageSync(CUR_LANGUAGE, lang);
      setLanguage(lang);
    },
    SET_TOKEN: async (state, token) => {
      state.token = token;
      uni.setStorageSync(CUR_TOKEN, token);
    },
    SET_USER_INFO: (state, info) => {
      state.userInfo = info;
      uni.setStorageSync(CUR_USERINFO, info);
    },
  },

  actions: {},
};
export default user;
